import { useTranslation } from 'react-i18next'
import { WidgetInputToggleField } from '../../rapid-ui'

export interface AiGeneratedLabelToggleProps {
	forced: boolean
	onForcedChange: (forced: boolean) => void
	detected: boolean
}

export function AiGeneratedLabelToggle({ forced, onForcedChange, detected }: AiGeneratedLabelToggleProps) {
	const { t } = useTranslation('common')

	return (
		<label className="grid grid-cols-[auto_1fr] items-center gap-x-2 py-2">
			<WidgetInputToggleField
				value={detected || forced}
				onChange={onForcedChange}
				disabled={detected}
			/>
			<span>{t('editor.widgets.forceAiGeneratedLabel')}</span>
			{detected && (
				<span className="col-start-2 text-xs text-grey-500">{t('editor.widgets.aiImageryDetected')}</span>
			)}
		</label>
	)
}
